import { render, staticRenderFns } from "./AddIpPolicyModal.vue?vue&type=template&id=7b37082d&scoped=true"
import script from "./AddIpPolicyModal.vue?vue&type=script&lang=ts"
export * from "./AddIpPolicyModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b37082d",
  null
  
)

export default component.exports